// src/store/authSlice.ts
import { createSlice, type PayloadAction } from "@reduxjs/toolkit";

interface AuthState {
  role: string | null;
  id: string | null;
  email: string | null;
  firstName: string | null;
  lastName: string | null;
  activeOrgId: string | null;
  photoUrl: string | null;
  loading: boolean;
}

const initialState: AuthState = {
  role: null,
  id: null,
  email: null,
  firstName: null,
  lastName: null,
  activeOrgId: null,
  photoUrl: null,
  loading: false,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    login: (
      state,
      action: PayloadAction<{
        role: string;
        id: string;
        email: string;
        firstName: string;
        lastName: string;
        activeOrgId?: string;
        photoUrl?: string | null;
      }>
    ) => {
      const { role, id, email, firstName, lastName, activeOrgId, photoUrl } = action.payload;
      state.role = role;
      state.id = id;
      state.email = email;
      state.firstName = firstName;
      state.lastName = lastName;
      state.activeOrgId = activeOrgId || null;
      state.photoUrl = photoUrl || null;
      // Don't set loading to false here - let the component control it
    },
    logout: (state) => {
      state.role = null;
      state.id = null;
      state.email = null;
      state.firstName = null;
      state.lastName = null;
      state.activeOrgId = null;
      state.photoUrl = null;
      state.loading = false;
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    updatePhotoUrl: (state, action: PayloadAction<string | null>) => {
      state.photoUrl = action.payload;
    },
    updateProfile: (
      state,
      action: PayloadAction<{
        firstName?: string;
        lastName?: string;
        photoUrl?: string | null;
        role?: string;
      }>
    ) => {
      if (action.payload.firstName !== undefined) {
        state.firstName = action.payload.firstName;
      }
      if (action.payload.lastName !== undefined) {
        state.lastName = action.payload.lastName;
      }
      if (action.payload.photoUrl !== undefined) {
        state.photoUrl = action.payload.photoUrl;
      }
      if (action.payload.role !== undefined) {
        state.role = action.payload.role;
      }
    },
  },
});

export const { login, logout, setLoading, updatePhotoUrl, updateProfile } = authSlice.actions;
export default authSlice.reducer;
